/**
 * Native <input> attributes that discourage password managers (1Password,
 * LastPass) from treating an AI-suggested review field as identity/login
 * data to save. Similar in spirit to FormTextField's show1Pass-gated
 * data-1p-ignore, but unconditional and without a show1Pass escape hatch —
 * these fields never hold personal login/identity data.
 */
export const passwordManagerIgnoreInputProps = {
  autoComplete: "off",
  "data-1p-ignore": true,
  "data-lpignore": true,
  "data-form-type": "other",
};
